<div class="player-speed" [ngClass]="{'player-speed--visible' : visible}">
  <div *ngFor="let speed of speeds" class="player-speed__item" (click)="setPlayerSpeed(speed)">
    {{speed}}x
  </div>
</div>
